import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'

const PromoImage = styled.div`
  width: 130%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  @media (max-width: 1700px) {
    width: 160%;
  }
  @media (max-width: 1440px) {
    width: 180%;
  }
  @media (max-width: 768px) {
    width: 170%;
  }
`

const HeaderImage = props => (
  <StaticQuery
    query={graphql`
      query {
        soccerImage: file(relativePath: { eq: "soccer_banner.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        americanFootballImage: file(relativePath: { eq: "nfl_banner.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        baseballImage: file(relativePath: { eq: "mlb_banner.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        aflImage: file(relativePath: { eq: "afl_banner.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        rugbyImage: file(relativePath: { eq: "nrl_banner.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        basketballImage: file(relativePath: { eq: "nba_banner.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        portlandBasketballImage: file(
          relativePath: { eq: "portland-basketball-stadium.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        mlsImage: file(relativePath: { eq: "soccer-stadium.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        basketballStadiumImage: file(
          relativePath: { eq: "basketball-stadium.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        soccerStadiumImage: file(relativePath: { eq: "soccer-stadium.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        boxingImage: file(relativePath: { eq: "boxing_banner.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        genericImage: file(relativePath: { eq: "generic_banner.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => {
      const { sport, status } = props
      if (sport === 'soccer' && status === 'inplay') {
        return (
          <PromoImage>
            <Img fluid={data.soccerStadiumImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      if (sport === 'soccer' && status === 'upcoming') {
        return (
          <PromoImage>
            <Img fluid={data.soccerStadiumImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      if (sport === 'soccer') {
        return (
          <PromoImage>
            <Img fluid={data.soccerImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      if (sport === 'basketball' && status === 'inplay') {
        return (
          <PromoImage>
            <Img
              fluid={data.basketballStadiumImage.childImageSharp.fluid}
              alt=""
            />
          </PromoImage>
        )
      }
      if (sport === 'basketball' && status === 'upcoming') {
        return (
          <PromoImage>
            <Img
              fluid={data.basketballStadiumImage.childImageSharp.fluid}
              alt=""
            />
          </PromoImage>
        )
      }
      if (sport === 'basketball') {
        return (
          <PromoImage>
            <Img fluid={data.basketballImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      if (sport === 'baseball') {
        return (
          <PromoImage>
            <Img fluid={data.baseballImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      if (sport === 'australian football') {
        return (
          <PromoImage>
            <Img fluid={data.aflImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      if (sport === 'rugby') {
        return (
          <PromoImage>
            <Img fluid={data.rugbyImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      if (sport === 'boxing') {
        return (
          <PromoImage>
            <Img fluid={data.boxingImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      if (sport === 'american football') {
        return (
          <PromoImage>
            <Img
              fluid={data.americanFootballImage.childImageSharp.fluid}
              alt=""
            />
          </PromoImage>
        )
      }
      if (sport === 'mls') {
        return (
          <PromoImage>
            <Img fluid={data.mlsImage.childImageSharp.fluid} alt="" />
          </PromoImage>
        )
      }
      return (
        <PromoImage>
          <Img fluid={data.genericImage.childImageSharp.fluid} alt="" />
        </PromoImage>
      )
    }}
  />
)

HeaderImage.propTypes = {
  sport: PropTypes.any,
  status: PropTypes.any,
}

export default HeaderImage
